<template>
  <v-container fluid class="help">
    <v-row align="center">
      <v-col>          
        <h1 class="text-center">Ideas Pod Booking</h1>
        <v-col class="text-center" v-if="isLeader">
          <br>
          <v-col cols="12">
            <v-btn
              outlined
              class="mr-4"
              color="grey darken-2"
              @click="dialog = !dialog"
            >
              Book Now
            </v-btn>
            <v-btn
              small
              text
              color="primary"
              @click="dialog = true; isAgreed=false"
            >
              See Do & Don't
            </v-btn>
          </v-col>
          
          <!-- booking dialog -->
          <v-dialog
            v-model="dialog"
            max-width="500px"
            persistent
          >
            <v-card v-if="isAgreed">
              <v-card-title>
                Booking Form 
              </v-card-title>
              <v-card-text>
                <br>
                <v-text-field 
                  label="CA Name" 
                  v-model="bookName"
                  :rules="rules.text"
                ></v-text-field>
                <v-text-field 
                  label="No Tel" 
                  v-model="bookTel" 
                  :rules="rules.text"
                ></v-text-field>
                <v-text-field 
                  label="Event Details" 
                  v-model="bookDetails" 
                  :rules="rules.text"
                ></v-text-field>
                <v-text-field 
                  label="No of Pax" 
                  v-model="bookPax" 
                  :rules="rules.text"
                ></v-text-field>

                <v-select
                  v-model="roomSelect"
                  :items="roomItems"
                  :rules="rules.text"
                  item-text="item"
                  item-value="value"
                  label="Room"
                  outlined
                  dense
                  class="px-2"
                  @input="checkRoomInput(roomSelect)"
                ></v-select>

                <v-menu
                  ref="menuDate"
                  v-model="menuDate"
                  :close-on-content-click="false"
                  :return-value.sync="dateOnBookMenu"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"   
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="dateOnBookMenu"
                      label="Date"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      :rules="rules.date"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="dateOnBookMenu"
                    no-title
                    scrollable
                    :min="pickerMinDate"
                    
                  >
                    <v-spacer></v-spacer>
                    <v-btn
                      text
                      color="primary"
                      @click="menuDate = false"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.menuDate.save(dateOnBookMenu)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>

                <!-- startTime Picker -->
                <v-menu
                  ref="menuStartTime"
                  v-model="menuStartTime"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  :return-value.sync="startTime"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="startTime"
                      label="Start Time"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      :rules="rules.text"
                    ></v-text-field>
                  </template>
                  <v-time-picker
                    v-if="menuStartTime"
                    v-model="startTime"
                    full-width
                    :max="endTime"
                  >
                    <v-spacer></v-spacer>
                    <v-btn
                      text
                      color="primary"
                      @click="menuStartTime = false"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.menuStartTime.save(startTime)"
                    >
                      OK
                    </v-btn>
                  </v-time-picker>
                </v-menu>

                <!-- endTime Picker -->
                <v-menu
                  ref="menuEndTime"
                  v-model="menuEndTime"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  :return-value.sync="endTime"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                  
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="endTime"
                      label="End Time"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      :rules="rules.text"
                    ></v-text-field>
                  </template>
                  <v-time-picker
                    v-if="menuEndTime"
                    v-model="endTime"
                    full-width
                    :min="startTime"
                  >
                    <v-spacer></v-spacer>
                    <v-btn
                      text
                      color="primary"
                      @click="menuEndTime = false"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.menuEndTime.save(endTime)"
                    >
                      OK
                    </v-btn>
                  </v-time-picker>
                </v-menu>

              </v-card-text>

              <v-card-actions>
                <v-btn
                  text
                  color="primary"
                  @click="isAgreed = false"
                >
                  See Do & Don't
                </v-btn>
                <v-spacer></v-spacer>

                <v-btn
                  text
                  color="primary"
                  @click="dialog = false"
                >
                  Cancel
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  :disabled="!bookingDialogIsValid"
                  @click="submitBooking()"
                >
                  Submit
                </v-btn>
              </v-card-actions>
            </v-card>

            <v-card v-else>
              <v-card-title>
                Do & Don't @ Ideas Pod Teras Legacy
              </v-card-title>
              <v-list-item dense>
                <v-list-item-content>
                  <ol type="1">
                    <li class="body-2">
                      Penggunaan Ideas Pod adalah berdasarkan tempahan. Tempahan hendaklah dibuat seawal 1 minggu atau sekurang-kurangnya 2 hari sebelum majlis/program berlangsung.
                    </li>
                    <li class="body-2">
                      Tempahan dan pemilihan bilik hendaklah mengikut bilangan peserta(pax).
                    </li>
                    <li class="body-2">
                      Bayaran yang minimum akan dikenakan.
                    </li>
                    <li class="body-2">
                      Anda perlu mengambil kad akses daripada admin dan mesti mengembalikannya kepada admin dalam tempoh masa 1 hari bekerja. Denda RM10/hari dikenakan jika lewat
                    </li>
                    <li class="body-2">
                      Denda RM100 dikenakan sekiranya kad akses hilang.
                    </li>
                    <li class="body-2">
                      Makan/minum hanya dibenarkan di Ideas Pod Hall sahaja. Tidak dibenarkan makan/minum di dalam Ideas Pod Room 1 & Room 2. Anda dibenarkan menggunakan kemudahan di pantri. Sila pastikan keadaan sentiasa kemas seperti di dapur rumah sendiri.
                    </li>
                    <li class="body-2">
                      Kebersihan tandas adalah tanggungjawab bersama.
                    </li>
                    <li class="body-2">
                      Sebelum keluar, PIC perlu memastikan semua susunan perabot berada di kedudukan asal, semua sampah/sisa makanan dibawa keluar apabila selesai menggunakan kemudahan Ideas Pod.
                    </li>
                    <li class="body-2">
                      Sila gunakan elektrik dengan jimat. Pastikan semua lampu, kipas, aircond dan barangan elektrik lain dimatikan sebelum meninggalkan Ideas Pod.
                    </li>
                    <li class="body-2">
                      PIC perlu memastikan pintu dikunci sebelum meninggalkan Ideas Pod.
                    </li>
                    <li class="body-2">
                      Tempat solat lelaki boleh didapati di tingkat 2.
                    </li>
                  </ol>

                </v-list-item-content>
              </v-list-item>
              <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn
                  text
                  color="primary"
                  @click="dialog = false"
                >
                  Cancel
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="isAgreed = true"
                >
                  I Agree
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          
          <!-- calender and event dialog -->
          <v-row class="fill-height">
            <v-col>
              <v-sheet height="64">
                <v-toolbar
                  flat
                  extended
                >
                  <v-spacer></v-spacer>
                  <v-btn
                    fab
                    text
                    small
                    color="grey darken-2"
                    @click="prev"
                  >
                    <v-icon small v-text="iconChevLeft">mdi-chevron-left</v-icon>
                  </v-btn>
                  <v-btn
                    fab
                    text
                    small
                    color="grey darken-2"
                    @click="next"
                  >
                    <v-icon small v-text="iconChevRight">mdi-chevron-right</v-icon>
                  </v-btn>
                  <v-toolbar-title v-if="$refs.calendar">
                    {{ $refs.calendar.title }}
                  </v-toolbar-title>
                  <v-spacer></v-spacer>

                  <template v-slot:extension>
                    <v-spacer></v-spacer>
                    <v-btn
                    outlined
                    class="mr-4"
                    color="grey darken-2"
                    @click="setToday"
                  >
                    Today
                  </v-btn>

                  <v-menu
                    bottom
                    right
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        outlined
                        color="grey darken-2"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <span>{{ typeToLabel[type] }}</span>
                        <v-icon right v-text="iconMenuDown">
                          mdi-menu-down
                        </v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item @click="type = 'day'">
                        <v-list-item-title>Day</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="type = 'week'">
                        <v-list-item-title>Week</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="type = 'month'">
                        <v-list-item-title>Month</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="type = '4day'">
                        <v-list-item-title>4 days</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                  <v-spacer></v-spacer>
                  </template>
                  
                </v-toolbar>
              </v-sheet>
              <br><br>
              <v-sheet height="600">
                <v-calendar
                  ref="calendar"
                  v-model="focus"
                  color="primary"
                  first-interval="6"
                  interval-count="19"
                  :events="events"
                  :event-color="getEventColor"
                  :type="type"
                  locale="en"
                  @click:event="showEvent"
                  @click:more="viewDay"
                  @click:date="viewDay"
                  @change="updateRange"
                ></v-calendar>
                <v-menu
                  v-model="selectedOpen"
                  :close-on-content-click="false"
                  :activator="selectedElement"
                  offset-x
                >
                  <v-card
                    color="grey lighten-4"
                    min-width="350px"
                    flat
                  >
                    <v-toolbar
                      :color="selectedEvent.color"
                      dark
                    >
                      <v-toolbar-title v-html="selectedEvent.name"></v-toolbar-title>
                      <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text>
                      <span><b>Event Details: </b></span>
                      <span v-html="selectedEvent.details"></span>
                      <br>
                      <span><b>Room: </b></span>
                      <span v-html="this.getRoomName( selectedEvent.room )"></span>
                      <br>
                      <span><b>Pax: </b></span>
                      <span v-html="selectedEvent.pax"></span>
                      <br>
                      <span><b>Access Card: </b></span>
                      <span v-html="selectedEvent.adm_access_card"></span>
                    </v-card-text>
                    <v-card-actions>
                      <v-btn
                        text
                        color="secondary"
                        @click="deleteConfirmDialog = true"
                        :disabled="!isUserOwner"
                      >
                        Delete
                      </v-btn>
                      <v-btn
                        text
                        color="secondary"
                        @click="selectedOpen = false"
                      >
                        Cancel
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-menu>
              </v-sheet>
            </v-col>
          </v-row>

          <!-- delete confirmation dialog -->
          <v-dialog
            v-model="deleteConfirmDialog"
            max-width="500px"
            persistent
          >
            <v-card>
              <v-card-title>
                Delete Confirmation
              </v-card-title>
              <v-card-text>
                <span class="body">
                  Delete Booking for : {{selectedEvent.details}}
                </span>
              </v-card-text>

              <v-card-actions>
                <v-btn
                  text
                  color="primary"
                  @click="deleteConfirmDialog = false"
                >
                  Cancel
                </v-btn>
                <v-btn
                  text
                  color="green"
                  @click="deleteBooking(selectedEvent.pushId)"
                >
                  Yes
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <!-- progress status (submit/delete) -->
          <v-snackbar
            v-model="snackbar"
            :timeout="snackbarTimeout"
            :multi-line="snackbarMultiLine"
            centered
          >
            {{ snackbarText }}
            <template v-slot:action="{ attrs }">
              <v-btn
                color="blue"
                text
                v-bind="attrs"
                @click="snackbar = false"
              >
                Close
              </v-btn>
            </template>
          </v-snackbar>

        </v-col>

        <!-- sign in as leader dialog -->
        <v-col v-else class="text-center">
          <br><br><br>
          <v-form
            ref="form"
            @submit.prevent="signInAsLeader"
          >
            <h3>Please enter leader's password to continue</h3>
            <br>                    
            <v-text-field
              v-model="password"

              label="Password"
              outlined
              dense
              :append-icon="show3 ? mdiEye : mdiEyeOff"
              :type="show3 ? 'text' : 'password'"
              @click:append="show3 = !show3"
            ></v-text-field>

            <v-btn :disabled="!formIsValid" color="primary" type="submit" >Sign In</v-btn>
            <br>
          </v-form>

          <v-overlay :value="overlay">
          <v-card
              class="mx-auto pa-4"
              max-width="344"
              outlined
          > 
              <br>
              <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
              <h3 class="title ma-3">Signing In</h3>
              <br>
              
              <!--
              <v-btn
              icon
              @click="overlay = false"
              x-large
              
              >
              <v-icon>mdi-close</v-icon>
              Dismiss
              </v-btn>-->

          </v-card>
          </v-overlay>
          <v-overlay :value="overlayError">
          <v-card
              class="mx-auto pa-4"
              max-width="344"
              outlined
          > 
              <br>
              <h3 class="title ma-3">Password Error !</h3><p class="sub-title">Please enter correct password.</p>
              
              <v-btn
              icon
              @click="overlayError = false"
              x-large
              
              >
              <v-icon>{{mdiClose}}</v-icon>
              Dismiss
              </v-btn>
          </v-card>
          </v-overlay>
          <v-overlay :value="overlayInfoError">
          <v-card
              class="mx-auto pa-4"
              max-width="344"
              outlined
          > 
              <br>
              <h3 class="title ma-3">Invalid Input.</h3><p class="sub-title">Please fill up the form.</p>
              
              <v-btn
              icon
              @click="overlayInfoError = false"
              x-large
              
              >
              <v-icon>{{mdiClose}}</v-icon>
              Dismiss
              </v-btn>
          </v-card>
          </v-overlay>
        </v-col>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mdiChevronLeft, mdiChevronRight, mdiMenuDown, mdiClose, mdiEye, mdiEyeOff } from '@mdi/js'
import { getDatabase, ref, push, set, onValue, remove } from "firebase/database";
import { dbPaths } from "../assets/dbPaths.js";

export default {
  data: () => ({
    
    mdiClose,
    mdiEye,
    mdiEyeOff,
    isLeader: '',
    overlay: false,
    overlayError: false,
    overlayInfoError: false,
    password: '',
    show3: false,
    storedAgentCode: '',

    dialog: false,
    isAgreed: false,
    bookName: '',
    bookDetails: '',
    bookTel: '',
    bookPax: '',
    bookColor: '',

    dateOnBookMenu: '',
    menuDate: false,
    pickerMinDate: '',
    pickerMaxDate: '',

    menuStartTime: false,
    startTime: '',
    menuEndTime: false,
    endTime: '',

    roomSelect: '',
    roomItems: [
      { item: 'IPod 1 (min 15 pax)', value: '1' }, 
      { item: 'IPod 2 (min 5 pax)', value: '2' }, 
      { item: 'IPod Hall (min 10 pax)', value: '3' }, 
      { item: 'IPod Pingpong (min 5 pax)', value: '4' }, 
    ],

    rules: {
      text: [val => (val || '').length > 0 || 'This field is required'],
      date: [val => val.length > 0 || 'Pick a date']
    },
    
    iconChevLeft: mdiChevronLeft,
    iconChevRight: mdiChevronRight,
    iconMenuDown: mdiMenuDown,
    focus: '',
    type: 'week',
    typeToLabel: {
      month: 'Month',
      week: 'Week',
      day: 'Day',
      '4day': '4 Days',
    },
    selectedEvent: {},
    selectedElement: null,
    selectedOpen: false,
    events: [],
    isUserOwner: false,

    deleteConfirmDialog: false,
    snackbar: false,
    snackbarText: '',
    snackbarTimeout: 5000,
    snackbarMultiLine: false,
      
  }),

  computed: {
    formIsValid() {
      return this.password 
    },
    
    bookingDialogIsValid() {
      return this.bookName && this.bookDetails && this.bookTel && this.bookPax && this.roomSelect && this.dateOnBookMenu && this.startTime && this.endTime 
    },    
  },

  mounted () {
    if (window.sessionStorage.getItem('isLeader') == 'true') {
      this.isLeader = true
    } else {
      this.isLeader = false
    }

    if(window.sessionStorage.getItem('agentCode')) {
      this.storedAgentCode = window.sessionStorage.getItem('agentCode').toUpperCase()
    } else {
      console.log('agentCode ERROR');
    }

    this.getBookingDateRange()

    //this.$refs.calendar.checkChange()
  },

  methods: {

    signInAsLeader() {
      this.overlay = true
      if (this.password === 'leader') {
        window.sessionStorage.setItem('isLeader', true)
        this.isLeader = true
        this.overlay = false
      } else {
        this.overlayError = true
        this.overlay = false
      }
    },

    viewDay ({ date }) {
      this.focus = date
      this.type = 'day'

      //console.log('focus + ' + this.focus);
    },
    getEventColor (event) {
      return event.color
    },
    setToday () {
      this.focus = ''
    },
    prev () {
      this.$refs.calendar.prev()
    },
    next () {
      this.$refs.calendar.next()
    },

    showEvent ({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event
        //console.log('showEvent push id: ' + event.pushId);
        //console.log('showEvent agent code: ' + event.agent_code);
        //console.log('window storedAgentCode: ' + this.storedAgentCode);
        this.isUserOwner = event.agent_code == this.storedAgentCode ? true:false
        this.selectedElement = nativeEvent.target
        requestAnimationFrame(() => requestAnimationFrame(() => this.selectedOpen = true))
      }

      if (this.selectedOpen) {
        this.selectedOpen = false
        requestAnimationFrame(() => requestAnimationFrame(() => open()))
      } else {
        open()
      }

      nativeEvent.stopPropagation()
    },

    updateRange () {

      //read data from db.............

      const events = []
      const db = getDatabase();

      //tuka mse prod.
      //const dbRef = ref(db, 'test/records/ipod_booking/2022');
      const dbRef = ref(db, dbPaths.toIPodBooking() + new Date().getFullYear());

      onValue(dbRef, (snapshot) => {

        snapshot.forEach((childSnapshot) => {
          events.push(childSnapshot.val())
        });

      }, {
        onlyOnce: true
      });

      this.events = events
    },

    //to get room info based on room no.
    getRoomName(roomNo) {
      switch (roomNo) {
        case "1" :
          return 'IPod 1';
        case "2" :
          return 'IPod 2';
        case "3" :
          return 'IPod Hall';
        case "4" :
          return 'IPod Pingpong';
      
        default:
          return 'error';
      }
    },

    
    //submit booking
    submitBooking() {

      const [year, month, day] = this.dateOnBookMenu.split('-');

      const [shours, sminutes] = this.startTime.split(':');
      const startTime = new Date(+year, month - 1, +day, +shours, +sminutes);

      const [ehours, eminutes] = this.endTime.split(':');
      const endTime = new Date(+year, month - 1, +day, +ehours, +eminutes);

      //console.log( 'startTIme before push. ==>' +startTime.getTime());
      //console.log( 'endTIme before push. ==>' +endTime.getTime());
      //console.log( 'year. ==>' +endTime.getFullYear());

      const db = getDatabase();
      const bookListRef = ref(db, dbPaths.toIPodBooking() + endTime.getFullYear());
      const newBookRef = push(bookListRef);
        
      set(newBookRef, {
        agent_code: window.sessionStorage.getItem('agentCode').toUpperCase(),
        name: this.bookName.toUpperCase(),
        no_tel: this.bookTel,
        details: this.bookDetails,
        room: this.roomSelect,
        color: this.bookColor,
        pax: this.bookPax,
        timed: true,
        start: startTime.getTime(),
        end: endTime.getTime(),
        pushId: newBookRef.key,

        adm_access_card: 'n/a',
        adm_is_approved: false,
        adm_approval_date: 'n/a',
        adm_book_date: new Date().toDateString(),
        adm_access_card_take_date: 'n/a',
        adm_access_card_return_date: 'n/a',
      })
      .then(() => {
          // Data saved successfully!
          //this.focus = this.dateOnBookMenu
          //this.type = 'day'
          this.updateRange()
          
          this.dialog = false

          this.snackbarMultiLine = false
          this.snackbar = true
          this.snackbarText = 'Booking Success.'
          
      })
      .catch((error) => {
          // The write failed...
          console.log(error.message);
          this.snackbarMultiLine = true
          this.snackbar = true
          this.snackbarText = 'ERROR == ' + error.message
      });

    },

    setEventColor(roomNumber) {
      switch (roomNumber) {
        case "1" :
          return 'green';
        case "2" :
          return 'blue';
        case "3" :
          return 'indigo';
        case "4" :
          return 'cyan';
      
        default:
          return 'grey';
      }
    },

    checkRoomInput(roomVal) {
      //console.log('roomSelect : ' + this.roomSelect);
      this.bookColor = this.setEventColor(roomVal)
      //console.log('bookColor : ' + this.bookColor);
      //console.log(this.dateOnBookMenu);
    },

    getBookingDateRange() {
      //prob when midnight.
      const date = new Date(Date.now());
      const dateMin = new Date(date.getTime());
      const dateMax = new Date(date.getTime());

      dateMin.setDate(dateMin.getDate())
      this.pickerMinDate = dateMin.toISOString().substr(0, 10)

      dateMax.setDate(dateMax.getDate() + 14)
      this.pickerMaxDate = dateMax.toISOString().substr(0, 10)
      
      //console.log('getDateRange || minDate : ' + this.pickerMinDate);
      //console.log('getDateRange || maxDate : ' + this.pickerMaxDate);
      
    },

    deleteBooking(pushId) {

      const date = new Date();
      const db = getDatabase();
      const bookingRef = ref(db, dbPaths.toIPodBooking() + date.getFullYear() + '/' + pushId);

      remove(bookingRef)
        .then(() => {
          //console.log("Remove succeeded.")

          this.deleteConfirmDialog = false
          this.snackbarMultiLine = false
          this.snackbar = true
          this.snackbarText = 'Booking Deleted.'
          this.updateRange()

          //this.focus = ''
          //this.type = 'week'

          this.selectedOpen = false
        })
        .catch(function(error) {
          console.log("Remove failed: " + error.message)

          this.selectedOpen = false
          this.deleteConfirmDialog = false
          this.snackbarMultiLine = true
          this.snackbar = true
          this.snackbarText = 'FAILED. ' + error.message
        });
    },

  },
  
}
</script>